import React from 'react';
import { isMobile } from 'react-device-detect';
import { selectTheme } from 'styles/theme/slice/selectors';
import { useSelector } from 'react-redux';
import { Col, Row } from 'antd';
import HomeSectionTitle from '../common/HomeSectionTitle';
import DemoButtons from '../common/DemoButtons';
import HomeSectionContainer from '../common/HomeSectionContainer';
import HomeLargeText from '../common/HomeLargeText';

export default function HomeNewDemoSection() {
  const customTheme = useSelector(selectTheme);

  const imgSrc = '/images/HomeImages/book-demo.svg';

  return (
    <HomeSectionContainer
      divStyles={{
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: '#fff',
        minHeight: 'fit-content',
      }}
      disableRow
    >
      <HomeLargeText
        extraStyles={{
          textAlign: 'center',
        }}
      >
        Get started <span style={{ backgroundColor: '#ffdc5d' }}>for free</span>
      </HomeLargeText>
      <Row style={{ width: '100%' }}>
        <Col
          xs={24}
          lg={12}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            margin: !isMobile && 'auto 0',
            order: isMobile && 2,
            padding: 12,
          }}
        >
          <img
            fetchpriority="high"
            style={{
              margin: '0px auto',
              height: '80%',
              width: '80%',
            }}
            src={imgSrc}
            alt="bodyImg"
          />
        </Col>
        <Col
          xs={24}
          lg={12}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            margin: !isMobile && 'auto 0',
            padding: 12,
            // paddingLeft: !isMobile && '4vmin',
            // ...(isMobile ? { marginBottom: '4vmin' } : { margin: 'auto 0' }),
          }}
        >
          <HomeSectionTitle
            extraStyles={{
              width: '100%',
              textAlign: 'center',
              marginTop: 0,
              fontSize: '4vmin',
            }}
          >
            Try it out first. Pay later.
          </HomeSectionTitle>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <DemoButtons
              extraDivStyles={{ display: 'flex', justifyContent: 'center' }}
            />
          </div>
        </Col>
      </Row>
    </HomeSectionContainer>
  );
}
